import { render, staticRenderFns } from "./CatalogManagement.vue?vue&type=template&id=3443540a&scoped=true"
import script from "./CatalogManagement.vue?vue&type=script&lang=js"
export * from "./CatalogManagement.vue?vue&type=script&lang=js"
import style0 from "./CatalogManagement.vue?vue&type=style&index=0&id=3443540a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3443540a",
  null
  
)

export default component.exports